export default __webpack_public_path__ + "static/SR USA - BRC Certificate - Food Safety-dca0437b1f9eb092f244a6e497320b85.pdf";